import { FileQuestion, Home } from "lucide-react";
import { Button } from "@/design-system/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface NotFoundPageProps {
  backToPath: string;
  backToTextKey: string; // Para i18n dinámico
  moduleName?: "patient" | "clinic";
}

export function NotFoundPage({
  backToPath,
  backToTextKey,
  moduleName = "patient",
}: NotFoundPageProps) {
  const navigate = useNavigate();
  const { t } = useTranslation(["common"]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center space-y-6">
      {/* Icono animado con sutil pulso */}
      <div className="relative p-6 rounded-2xl bg-primary/5 border border-primary/10 animate-fade-in">
        <FileQuestion size={48} className="text-primary animate-bounce-slow" />
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-amber-500 rounded-full animate-ping" />
      </div>

      <div className="space-y-2 max-w-md">
        <h2 className="text-3xl font-black tracking-tight text-foreground">
          {t("common:not_found.title")}
        </h2>
        <p className="text-sm font-medium text-muted-foreground leading-relaxed">
          {t("common:not_found.sub_title")}
        </p>
      </div>

      {/* Botón adaptativo según el módulo */}
      <Button
        onClick={() => navigate(backToPath)}
        className="rounded-xl font-bold shadow-sm flex items-center gap-2 active:scale-98 transition-all px-6 py-5 cursor-pointer"
      >
        <Home size={16} />
        {t(backToTextKey)}
      </Button>

      <span className="text-[10px] font-mono tracking-widest text-muted-foreground/40 uppercase">
        {t("common:not_found.footer_title")} {moduleName}
      </span>
    </div>
  );
}
